module.exports = __webpack_public_path__ + "static/img/ikonaPobierz-ON.45c90487.png";